import React from 'react'
import { selectRateByShop } from '../../redux/features/todayRateSlice';
import { useSelector } from 'react-redux';

const Layout = ({children, showRedBar}) => {
  const shopName = useSelector((state) => state.shop.name);
  const todayRate = useSelector(state => selectRateByShop(state, shopName));
  return (
    <>
    {showRedBar && shopName === 'tama' && <div className='w-full bg-red-200 flex justify-center text-2xl h-12 items-center'><h4>Rate ลูกค้าทั่วไปวันนี้ {todayRate}</h4></div>}
    <div style={{minHeight: "80vh"}} className="--pad">
        {children}
    </div>
    </>
  )
}

export default Layout